import { Component, OnInit, OnDestroy, Renderer2, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { SearchBarAddressesComponent } from "./components/search-bar-addresses/search-bar-addresses.component";
import { CommonModule } from '@angular/common';
import { ModalViewLocationService } from './service/modal-view-location.service';
import { ListAddressesComponent } from './components/list-addresses/list-addresses.component';
import { MapViewComponent } from './components/map-view/map-view.component';
import { CurrentLocationButtonComponent } from './components/current-location-button/current-location-button.component';
import { FormSaveAddressComponent } from "./form-save-address/form-save-address.component";
import { FormSaveAddressService } from './form-save-address/service/form-save-address.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'shared-modal-view-location',
  standalone: true,
  imports: [SearchBarAddressesComponent, ListAddressesComponent, MapViewComponent, CurrentLocationButtonComponent, CommonModule, FormSaveAddressComponent],
  templateUrl: './modal-view-location.component.html',
  styleUrl: './modal-view-location.component.css',
changeDetection:ChangeDetectionStrategy.OnPush
})
export class ModalViewLocationComponent implements OnInit, OnDestroy {
  // Ubicación actual para mostrar en el mapa
  currentLocation: { lat: number, lng: number } = { lat: 19.03793, lng: -98.20346 }; // Ciudad de Puebla por defecto
  selectedAddress: string = '';
  // Variable para controlar la visibilidad del mapa
  showMap: boolean = false;

  // Suscripciones para limpiar en OnDestroy
  private subscriptions: Subscription = new Subscription();


  constructor(
    public modalViewLocationService: ModalViewLocationService,
    private formSaveAddressService: FormSaveAddressService,
    private renderer: Renderer2,
    private cdr: ChangeDetectorRef
  ) {

  }
  ngOnInit(): void {
    // Suscribirse al estado del modal para controlar el scroll del body
    this.subscriptions.add(
      this.modalViewLocationService.isOpen$.subscribe({
        next: (isOpen) => {
          const body = this.renderer.selectRootElement('body', true);
          if (isOpen) {
            // Agregar clase para prevenir scroll cuando el modal se abre
            this.renderer.addClass(body, 'no-scroll');
          } else {
            // Quitar clase para permitir scroll cuando el modal se cierra
            this.renderer.removeClass(body, 'no-scroll');
          }
          this.cdr.detectChanges();
        }
      })
    );

    this.subscriptions.add(
      this.modalViewLocationService.visibleMap$.subscribe({
        next: value => {
          if (this.modalViewLocationService.isEditMode) {
            this.showMap = value;
            let adderss = this.modalViewLocationService.editableAddress;
            this.onLocationSelected({ location: { lat: +adderss.ad_latitude, lng: +adderss.ad_longitude! }, address: adderss.ad_full_address });
          } else {
            this.showMap = value;
          }
          this.cdr.detectChanges();
        }
      })
    );
  }

  ngOnDestroy(): void {
    // Limpiar todas las suscripciones
    this.subscriptions.unsubscribe();

    // Asegurar que se quite la clase no-scroll al destruir el componente
    const body = this.renderer.selectRootElement('body', true);
    this.renderer.removeClass(body, 'no-scroll');
  }

  // Método para cerrar el modal
  closeModal(): void {
    this.showMap = false;
    this.modalViewLocationService.toggleModal(false);
  }

  // Método para manejar la selección de ubicación desde el buscador
  onLocationSelected(data: { location: { lat: number, lng: number }, address: string }): void {
    // console.log('Ubicación seleccionada en el modal:', data);

    this.formSaveAddressService.full_address = data.address;
    this.formSaveAddressService.latitude = data.location.lat.toString();
    this.formSaveAddressService.longitude = data.location.lng.toString();

    // Actualizar la ubicación actual para el mapa
    this.currentLocation = data.location;
    this.selectedAddress = data.address;

    // Guardar la ubicación seleccionada en el servicio
    this.modalViewLocationService.setSelectedLocation(data.location, data.address);

    // Forzar la detección de cambios para actualizar el mapa
    setTimeout(() => {
      // console.log('Actualizando mapa con nueva ubicación:', this.currentLocation);
    }, 100);

  }

  // Método para alternar la visibilidad del mapa
  toggleMapVisibility(): void {
    this.showMap = !this.showMap;

    // Añadir clase al contenedor del modal cuando se muestra el mapa
    setTimeout(() => {
      const modalContainer = document.querySelector('.fixed.inset-0');
      if (modalContainer) {
        if (this.showMap) {
          modalContainer.classList.add('modal-map-visible');
        } else {
          modalContainer.classList.remove('modal-map-visible');
        }
      }
    }, 0);
    // console.log('Visibilidad del mapa:', this.showMap);
  }
}
